export default {
    update: {
        success: 'Panel successfully updated',
        error: 'Panel could not be updated'
    },

    delete: {
        success: 'Panel successfully deleted',
        error: 'Panel could not be deleted'
    },

    setEnabled: {
        success: 'Panel state successfully updated',
        error: 'Panel state could not be updated'
    }
}
